import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ReconciliationLink, ReconciliationWidget } from "components/accounting";
import { GridR, ViewPanel, WidgetArea } from "components/common";
import { Grid } from "@mui/material";
import { OwnersWidgetContainer } from "components/shareRegister";
import ShortcutsWidget from "./widgets/shortcuts/widget";
import DocumentationWidget from "./widgets/documentation/documentationWidget";
import { CompanyInfoWidget } from "components/company";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AdvisoryViewDashboardContent: React.FC = () => {
  // Todo: remember to add loadings inside widgets

  const reconciliationDate = useSelector((state: AppState) => state.auth.selectedCompany.reconciliationDate);

  return (
    <>
      <Grid container rowGap={3} columnSpacing={3}>
        <GridR item md={7} xs={12}>
          <WidgetArea>
            <ViewPanel
              icon={IconDefinitionConstants.WReports}
              title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.Reconciliation)}
              appearance="lg"
              gridSize="lg"
              topRightContent={reconciliationDate ? <ReconciliationLink /> : <></>}
            >
              <ReconciliationWidget reconciliationDate={reconciliationDate} />
            </ViewPanel>

            <OwnersWidgetContainer />
          </WidgetArea>
        </GridR>
        <GridR item md={5} xs={12}>
          <WidgetArea>
            <ShortcutsWidget />
            <DocumentationWidget />
            <ViewPanel
              icon={IconDefinitionConstants.WCompany}
              title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.CompanyInformation)}
              appearance="lg"
              gridSize="lg"
              topRightContent={<></>}
            >
              <CompanyInfoWidget />
            </ViewPanel>
          </WidgetArea>
        </GridR>
      </Grid>
    </>
  );
};

export default AdvisoryViewDashboardContent;
